import { FileServiceError } from "./FileServiceError";

export class FileServiceFileNameError extends FileServiceError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "FileServiceFileNameError";
  }
}
